import ExtendedSearchModal from './ExtendedSearchModal'
export default ExtendedSearchModal
